import { captureException } from '@sentry/react';
import {
  useBookingAddress,
  useBookingCars,
  useBookingCarsInsuranceInfo,
  useBookingSelectedSalesItemsCars,
  useBookingTimeWindow
} from 'noddi-web';
import { useEffect, useMemo } from 'react';
import { useCurrentBrand } from '../stores/BrandStore/brandStore';
import { useBookingSummaryServiceDepartment } from './useBookingSummaryServiceDepartment';

export function useGetBookingTrackingParams() {
  const cars = useBookingCars();
  const salesItems = useBookingSelectedSalesItemsCars();
  const selectedAddress = useBookingAddress();
  const timeWindow = useBookingTimeWindow();
  const insuranceInfo = useBookingCarsInsuranceInfo();
  const { currentBrand } = useCurrentBrand();
  const { data: serviceDepartmentData } = useBookingSummaryServiceDepartment();

  // Keep a failed analytics calculation stable across unrelated rerenders.
  const result = useMemo(() => {
    try {
      const params = {
        cars: cars.map((car) => car.licensePlate.number),
        numberOfCars: cars.length,
        address: selectedAddress,
        salesItems: salesItems.map((item) => item.salesItemId),
        pickUpAddresses: [
          ...new Set(
            salesItems.map((item) => item.metaData?.selectedTireHotelPickUpAddress?.id ?? null).filter(Boolean)
          )
        ],
        tireHotelLocations: [
          ...new Set(salesItems.map((item) => item.metaData?.selectedTireHotelLocation?.id ?? null).filter(Boolean))
        ],
        bookingCategories: [...new Set(salesItems.map((item) => item.bookingCategoryType))],
        timeWindow,
        bookingInsuranceInfo: insuranceInfo,
        brand: currentBrand,
        serviceDepartmentName: serviceDepartmentData?.name
      };
      return { params, error: undefined };
    } catch (error) {
      return { params: null, error };
    }
  }, [cars, salesItems, selectedAddress, timeWindow, insuranceInfo, currentBrand, serviceDepartmentData?.name]);
  useEffect(() => {
    if (result.error !== undefined) {
      captureException(result.error);
    }
  }, [result.error]);
  return result.params;
}
